module.exports = __webpack_public_path__ + "img/tpc-6.f93b37cd.jpg";